import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  RequestReplaceCertificate,
  requestReplaceCertificateFailed,
  requestReplaceCertificateSuccess
} from '../../actions/resources/Certificate';
import ManageResource from '../../api/resources/ManageResource';
import * as Constants from '../../constants/resources';

function* getReplaceCertificate(action: RequestReplaceCertificate) {
  try {
    yield call(ManageResource.replaceCertificate, action.payload);
    yield put(requestReplaceCertificateSuccess());
  } catch (error) {
    yield put(requestReplaceCertificateFailed(error));
  }
}

function* watchForReplaceCertificate() {
  yield takeLatest(Constants.REPLACE_CERTIFICATE, getReplaceCertificate);
}

export default function* replaceCertificateSaga() {
  yield all([watchForReplaceCertificate()]);
}
